import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgImageSliderModule } from 'ng-image-slider';
import { BasicLayoutModule } from './basic-layout/basic-layout.module';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FooterComponent } from './navigation/footer/footer.component';
import { HeaderComponent } from './navigation/header/header.component';
import { SidebarComponent } from './navigation/sidebar/sidebar.component';
import { Page404Component } from './content/page404/page404.component';
import { MainAreaComponent } from './content/main-area/main-area.component';

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    HeaderComponent,
    SidebarComponent,
    Page404Component,
    MainAreaComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BasicLayoutModule,
    NgImageSliderModule
  ],
  providers: [
    Title
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
